var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isCompany)?_c('employee',{attrs:{"companyNode":_vm.node,"selection":true,"identity":2}}):_c('employeeAll',{attrs:{"identity":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }